import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import CryptoPage from "./crypto";
import CryptoEmailsPage from "./crypto-emails";
import reportWebVitals from "./reportWebVitals";
import AboutPage from "./AboutPage";
import ServicesPage from "./ServicesPage";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ExamplePage } from "./components/constructor/example-page/example";
import ChinChinPage from "./components/chin-chin/chin-chin";
import UXPage from "./UXPage";

//cases
import { CaseBoostpad } from "./components/boostpad/example-page/example";
import { CaseSharxDesignSystem } from "./components/sharx-design-system/sharx-design-system/sharx-design-system";

//lead-magints
import { LeadMagnit1 } from "./components/lead-magnit-1/lead-magnit-1/lead-magnit-1";
import EquiPage from "./components/equi/equi";
import VmestePage from "./components/vmeste/vmeste";
import InvestPage from "./components/invest/invest";
import CasesPage from "./CasesPage";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route
          path="/"
          element={<App />}
          exact
        />
        <Route
          path="/cases"
          element={<CasesPage />}
          exact
        />
        <Route
          path="/about"
          element={<AboutPage />}
          exact
        />
        <Route
          path="/services"
          element={<ServicesPage />}
          exact
        />
        <Route
          path="/constructor"
          element={<ExamplePage />}
          exact
        />
        <Route
          path="/crypto"
          element={<CryptoPage />}
          exact
        />
        <Route
          path="/web3-eq-product-page"
          element={<EquiPage />}
          exact
        />
        <Route
          path="/chin-chin"
          element={<ChinChinPage />}
          exact
        />
        <Route
          path="/email"
          element={<CryptoEmailsPage />}
          exact
        />
        <Route
          path="/vmeste"
          element={<VmestePage />}
          exact
        />
        <Route
          path="/invest"
          element={<InvestPage />}
          exact
        />
        <Route
          path="/audit"
          element={<UXPage />}
          exact
        />
        <Route
          path="/boostpad-ux-ui-launchpad"
          element={<CaseBoostpad />}
          exact
        />
        <Route
          path="/sharx-design-system"
          element={<CaseSharxDesignSystem />}
          exact
        />

        <Route
          path="/web3-ux-ui-problems"
          element={<LeadMagnit1 />}
          exact
        />
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
